"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowCheckBoxSetEditor = /** @class */ (function (_super) {
    __extends(CardRowCheckBoxSetEditor, _super);
    function CardRowCheckBoxSetEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "20px" };
        return _this;
    }
    CardRowCheckBoxSetEditor.prototype.componentWillMount = function () {
        var _clone = {};
        for (var i = 0; i < this.props.items.length; i++) {
            _clone[this.props.items[i].key] = { checked: this.props.items[i].checked, title: this.props.items[i].title };
        }
        this.setState({
            dict: _clone
        });
    };
    CardRowCheckBoxSetEditor.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            var _clone = {};
            for (var i = 0; i < nextProps.items.length; i++) {
                _clone[nextProps.items[i].key] = { checked: nextProps.items[i].checked, title: nextProps.items[i].title };
            }
            this.setState({
                dict: _clone
            });
        }
    };
    CardRowCheckBoxSetEditor.prototype.onCheckBoxChanged = function (key, e) {
        var _this = this;
        var _clone = {};
        Object.assign(_clone, this.state.dict);
        _clone[key].checked = !_clone[key].checked;
        this.setState({ dict: _clone }, function () {
            if (_this.props.onChecked) {
                _this.props.onChecked(key, _clone[key].checked);
            }
        });
    };
    CardRowCheckBoxSetEditor.prototype.getRenderObjects = function () {
        var _ret = [];
        for (var i = 0; i < this.props.items.length; i++) {
            _ret.push(React.createElement(antd_1.Checkbox, { style: { width: "122px" }, checked: this.state.dict[this.props.items[i].key].checked, disabled: this.props.disabled, key: this.props.items[i].key, onChange: this.onCheckBoxChanged.bind(this, this.props.items[i].key) }, this.props.items[i].title));
        }
        return _ret;
    };
    CardRowCheckBoxSetEditor.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            React.createElement("div", { style: { display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" } }, this.getRenderObjects())));
    };
    return CardRowCheckBoxSetEditor;
}(React.Component));
exports.default = CardRowCheckBoxSetEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowCheckBoxSetEditor.tsx
// module id = 1961
// module chunks = 0